import JsonPackagingFr from './fr/packaging.json' with { type: 'json' };;

export default {
  'fr': JsonPackagingFr
};